import CreditLimitEnquiryModal from './creditLimitEnquiryModal'

export default CreditLimitEnquiryModal
